Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_COMPONENT = exports.ADD_COMPONENT = 'ADD_COMPONENT';
var REMOVE_COMPONENT = exports.REMOVE_COMPONENT = 'REMOVE_COMPONENT';
var WATCH_COMPONENT = exports.WATCH_COMPONENT = 'WATCH_COMPONENT';
var SET_QUERY = exports.SET_QUERY = 'SET_QUERY';
var SET_QUERY_OPTIONS = exports.SET_QUERY_OPTIONS = 'SET_QUERY_OPTIONS';
var EXECUTE_QUERY = exports.EXECUTE_QUERY = 'EXECUTE_QUERY';
var UPDATE_HITS = exports.UPDATE_HITS = 'UPDATE_HITS';
var UPDATE_AGGS = exports.UPDATE_AGGS = 'UPDATE_AGGS';
var ADD_CONFIG = exports.ADD_CONFIG = 'ADD_CONFIG';
var ADD_APPBASE_REF = exports.ADD_APPBASE_REF = 'ADD_APPBASE_REF';
var LOG_QUERY = exports.LOG_QUERY = 'LOG_QUERY';
var LOG_COMBINED_QUERY = exports.LOG_COMBINED_QUERY = 'LOG_COMBINED_QUERY';
var SET_VALUE = exports.SET_VALUE = 'SET_VALUE';
var PATCH_VALUE = exports.PATCH_VALUE = 'PATCH_VALUE';
var CLEAR_VALUES = exports.CLEAR_VALUES = 'CLEAR_VALUES';
var SET_LOADING = exports.SET_LOADING = 'SET_LOADING';
var SET_ERROR = exports.SET_ERROR = 'SET_ERROR';
var SET_STREAMING = exports.SET_STREAMING = 'SET_STREAMING';
var PUSH_TO_STREAM_HITS = exports.PUSH_TO_STREAM_HITS = 'PUSH_TO_STREAM_HITS';
var SET_TIMESTAMP = exports.SET_TIMESTAMP = 'SET_TIMESTAMP';
var SET_HEADERS = exports.SET_HEADERS = 'SET_HEADERS';
var SET_MAP_DATA = exports.SET_MAP_DATA = 'SET_MAP_DATA';
var SET_QUERY_LISTENER = exports.SET_QUERY_LISTENER = 'SET_QUERY_LISTENER';
var STORE_KEY = exports.STORE_KEY = '__REACTIVESEARCH__';
var SET_SEARCH_ID = exports.SET_SEARCH_ID = 'SET_SEARCH_ID';
var SET_PROMOTED_RESULTS = exports.SET_PROMOTED_RESULTS = 'SET_PROMOTED_RESULTS';